export default __webpack_public_path__ + "static/media/dark-theme-vid-logo.769383c8.svg";